<template lang="pug">
  include ../../../views/desktop/shared/iconMixins.pug
  .profile.xs-f-small.max-at-tweak.text-left
    .logo(:class="paymentProfileClass(profile.paymentGateway, profile.ccType)")

    .info-wrap
      .info(v-if="profile.paymentGateway == 'braintree'")
        p {{ profile.ccType }} &#42;&#42;&#42;&#42;{{ profile.ccNum }}
        p {{ profile.displayGoodThru }}

      .info(v-else-if="thirdPartyProfile" :class="{ 'mt-15': thirdPartyProfile }")
        p Created on {{ profile.createdAt | moment("MM/DD/YY") }}

      Pill(v-if="profile.is_default" text="default" data-mr-ass="default")
      Pill(v-if="profile.isDeclined" text="Needs attention" variant="danger")
      Pill(v-if="profile.expiresIn < 30 && profile.expiresIn > 0" text="expires soon" variant="light-danger")
      Pill(v-if="profile.expiresIn < 0" text="expired" variant="danger")

    .controls.pull-right(:class="{ 'mt-15': thirdPartyProfile }")
      button.btn-link.transparent-btn(v-if="edit" @click="editPaymentMethod()" role="button" data-mr-ass="edit-payment-button")
        span.icon-edit
        span.ada-tooltip Edit Payment

      button.btn-link.transparent-btn(v-if="remove" @click="deletePaymentModal(profile)" data-mr-ass="remove-payment-button")
        +icon-bin

</template>

<script>
  import { mapActions, mapMutations, mapGetters } from "vuex";
  import Pill from "../Pill";
  import { paymentProfileClass } from "../../utilities/mrVueUtils";

  export default {
    name: "PaymentProfile",
    components: {
      Pill
    },

    props: {
      profile: {},
      edit: {
        type: Boolean,
        required: false,
        default: false
      },

      remove: {
        type: Boolean,
        required: false,
        default: false
      },

      editMethod: {
        type: Function,
        required: false,
        default: null
      }
    },

    computed: {
      ...mapGetters('payments', ['profileIsEditable']),

      thirdPartyProfile() {
        return ['paypal', 'amazon'].includes(this.profile.paymentGateway);
      }
    },

    mounted() {
      let editPayment = this.$route.query.editPayment;

      if (this.profile.paymentGateway == 'amazon') {
        this.setValidAmazonSession(Boolean(this.$cookies.get('amazon_Login_accessToken')));
      }

      if (editPayment && editPayment == this.profile.paymentProfileId || editPayment == 'amazon' && this.profile.paymentGateway == 'amazon') {
        this.editPaymentMethod(this.profile);
      }

    },

    methods: {
      ...mapActions('payments', [
        'editPaymentModal',
        'deletePaymentModal'
      ]),

      ...mapMutations('payments', [
        'setValidAmazonSession'
      ]),

      editPaymentMethod() {
        if (!this.editMethod) {
          return this.editPaymentModal(this.profile);
        }

        this.editMethod(this.profile);
      },

      paymentProfileClass
    }
   }
</script>

<style scoped lang="stylus">
  .logo
    height 3em
    width 3.62em

  .info-wrap
    padding-left 1em

  .logo
  .info-wrap
    display inline-block
    vertical-align top

  .controls
    button
      padding 0 0.5em


</style>